<app-view-item *ngIf="disabled" [text]="selected?.code"></app-view-item>

<div nz-row *ngIf="!disabled" nzAlign="middle" nzGutter="0">
  <div nz-col nzFlex="auto">
    <nz-select 
      nzShowSearch 
      nzServerSearch 
      [nzAllowClear]="true" 
      [nzBackdrop]="addBackdrop"
      [nzFilterOption]="nzFilterOption"
      (nzOnSearch)="search($event)" 
      (nzOpenChange)="search('')"
      (nzScrollToBottom)="loadMore()"
      [nzCustomTemplate]="displayTpl" 
      [(ngModel)]="value"
      (ngModelChange)="valueChanged($event)"
      [nzDropdownMatchSelectWidth]="false"
      nzDropdownClassName="dropdownSelect"
      class="width-100">
      <ng-template #displayTpl let-selected>
        {{ selected.nzLabel }}
      </ng-template>
      <ng-container *ngFor="let item of list">
        <nz-option *ngIf="!searching" [nzValue]="getValue(item)" [nzLabel]="item.code" nzCustomContent>
          <app-bir-select-item [bir]="item"></app-bir-select-item>
        </nz-option>
      </ng-container>
    </nz-select>
  </div>
</div>
